import { getCubaTimeParts } from '../time/cubaTime';

export const AGREEMENT_REQUEST_LIMIT_PER_QUARTER = 2;

export type AgreementRequestStatus = 'pending' | 'approved' | 'rejected';

export interface StaffAgreementChangeRequest {
  id: string;
  requesterId: string;
  requesterName: string;
  requesterRole: 'lister' | 'runner';
  houseId: string;
  quarterKey: string;
  reason: string;
  currentCommission: number;
  status: AgreementRequestStatus;
  clientRequestId?: string;
  decidedCommission?: number | null;
  reviewerNote?: string | null;
  createdAt?: number | null;
  reviewedAt?: number | null;
}

export interface StaffAgreementRequestSummary {
  requests: StaffAgreementChangeRequest[];
  quarterKey: string;
  used: number;
  remaining: number;
}

export function latestPendingAgreementRequest(
  requests: StaffAgreementChangeRequest[],
): StaffAgreementChangeRequest | null {
  return requests.find((request) => request.status === 'pending') ?? null;
}

export function currentAgreementQuarter(now = new Date()): string {
  const { year, month } = getCubaTimeParts(now);
  return `${year}-Q${Math.floor((month - 1) / 3) + 1}`;
}
